import { ReactNode, Suspense } from 'react';
import { Skeleton } from '../skeleton';

interface LazyPageProps {
  children: ReactNode;
}

export function LazyPage({ children }: LazyPageProps) {
  return <Suspense fallback={<Skeleton variant='page' />}>{children}</Suspense>;
}
